'use client';

import { cn } from '../../utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClasses = {
    sm: 'h-6 w-6 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
  };

  return (
    <div
      className={cn(
        'inline-block animate-spin rounded-full border border-primary border-t-transparent',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

/**
 * Centered spinner component for full-page or modal loading states
 */
export function CenteredSpinner({ size = 'lg' }: Pick<SpinnerProps, 'size'>) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spinner size={size} />
    </div>
  );
}
